<template>
  <div>
    <b-row class="no-gutters">
      <b-col cols="8" class="d-flex mb-3">
        <h1 class="font-weight-bold header-main text-uppercase mb-0">
          หมายเลขคำสั่งซื้อ : {{ orderDetail.invoiceNo }}
        </h1>
        <router-link
          v-if="!isOrderMain"
          :to="'/order/main/details/' + mainOrderId"
        >
          <b-button class="btn-main ml-3">
            <span>ดูข้อมูลออเดอร์หลัก </span>
          </b-button>
        </router-link>
      </b-col>
      <b-col class="text-right d-flex justify-content-end mb-3">
        <span
          class="pr-2 header-btn pointer my-auto"
          v-if="
            orderDetail.orderStatusId == 9 || orderDetail.orderStatusId == 4
          "
          @click="holdOrder"
          >พักรายการ</span
        >
        <span
          class="pr-2 header-btn pointer my-auto"
          v-if="
            orderDetail.orderStatusId == 13 || orderDetail.orderStatusId == 16
          "
          @click="reRunOrder"
          >ย้ายไปยังรายการรอยืนยันคำสั่งซื้อ</span
        >
        <b-button variant="link" class="px-1 pt-2 my-auto" @click="handleRoute">
          <u>ย้อนกลับ</u>
        </b-button>
      </b-col>
    </b-row>

    <div class="mt-2">
      <div class="p-4 bg-white">
        <b-container class="p-0">
          <b-row>
            <b-col sm="8">
              <p class="mb-0 mr-4">
                <strong
                  ><span
                    >วัน / เวลา ที่ทำการสั่งซื้อ :ㅤ{{
                      new Date(orderDetail.createdTime) | moment($formatDate)
                    }}</span
                  >
                  <span class="text-gray"
                    >ㅤ({{
                      new Date(orderDetail.createdTime) | moment($formatTime)
                    }})</span
                  ></strong
                >
              </p>
            </b-col>
            <b-col sm="2" class="text-right d-flex justify-content-end">
              <p class="mb-0">
                <strong>สถานะคำสั่งซื้อ :</strong>
              </p>
            </b-col>
            <b-col sm="2" class="text-right d-flex justify-content-end">
              <p class="mb-0">
                {{ orderDetail.orderStatus }}
              </p>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col sm="8" class="d-flex align-items-center">
              <p class="mb-0 mr-4">
                <strong
                  ><span
                    >ช่องทางการชำระเงิน :ㅤ
                    {{ orderDetail.paymentType }}ㅤ</span
                  ></strong
                >
                <span
                  v-if="orderDetail.paymentTypeId == 1"
                  class="modal-link pointer text-purple-1"
                  @click="openPaymentDetail"
                  >ดูหลักฐานการโอนเงิน</span
                >
              </p>
            </b-col>
            <b-col sm="2" class="justify-content-end d-flex align-items-center">
              <p class="mb-0">
                <strong>ช่องทางการสั่งซื้อ :</strong>
              </p>
            </b-col>
            <b-col sm="2">
              <div>
                <div
                  v-if="orderDetail.imageUrl"
                  class="seller-image"
                  v-bind:style="{
                    'background-image': 'url(' + orderDetail.imageUrl + ')',
                  }"
                ></div>
                <p v-else class="mb-0">
                  <strong>{{ orderDetail.salesChannel }} </strong>
                </p>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>

      <b-row class="mt-3 header-detail">
        <b-col sm="4" class="pr-0">
          <div class="p-4 bg-white">
            <b-container class="p-0">
              <p>
                <b-row>
                  <b-col>
                    <strong>รายละเอียดผู้สั่งซื้อ</strong>
                  </b-col>
                  <b-col class="text-right d-flex justify-content-end">
                    <span class="modal-link-active text-purple-1">พิมพ์</span>
                    <span
                      :class="classEditTaxInvoice"
                      @click="openTaxInvoice('shipping')"
                      >เพิ่ม/แก้ไข</span
                    >
                  </b-col>
                </b-row>
              </p>
              <p class="mb-0">
                {{ orderAddress.firstname }} {{ orderAddress.lastname }} ,
                {{ orderAddress.telephone }}
              </p>
              <p>
                {{ orderAddress.address }} {{ orderAddress.road }}
                {{ orderAddress.province }} {{ orderAddress.district }}
                {{ orderAddress.subdistrict }} {{ orderAddress.zipcode }}
              </p>
            </b-container>
          </div>
        </b-col>
        <b-col sm="4" class="pr-0">
          <div class="p-4 bg-white">
            <b-container class="p-0">
              <p>
                <b-row>
                  <b-col>
                    <strong>ข้อมูลใบกำกับภาษี</strong>
                  </b-col>
                  <b-col class="text-right d-flex justify-content-end">
                    <span class="modal-link-active text-purple-1">พิมพ์</span>
                    <span
                      :class="classEditTaxInvoice"
                      @click="openTaxInvoice('billing')"
                      >เพิ่ม/แก้ไข</span
                    >
                  </b-col>
                </b-row>
              </p>
              <p class="mb-0">
                {{ orderTaxAddress.firstname }} {{ orderTaxAddress.lastname }} ,
                {{ orderTaxAddress.telephone }}
              </p>
              <p class="mb-0">
                {{ orderTaxAddress.address }} {{ orderTaxAddress.road }}
                {{ orderTaxAddress.province }} {{ orderTaxAddress.district }}
                {{ orderTaxAddress.subdistrict }} {{ orderTaxAddress.zipcode }}
              </p>
              <p>
                เลขประจำตัวผู้เสียภาษี:
                {{ orderTaxAddress.tax != null ? orderTaxAddress.tax : "-" }}
              </p>
            </b-container>
          </div>
        </b-col>
        <b-col sm="4">
          <div class="p-4 bg-white">
            <b-container class="p-0">
              <p>
                <b-row>
                  <b-col>
                    <strong>รายละเอียดการจัดส่ง</strong>
                  </b-col>
                  <b-col>
                    <b-dropdown
                      id="dropdown-1"
                      class="btn-brand-selected small-dropdown print-selected"
                      right
                      no-flip
                      :disabled="
                        orderDetail.orderStatusId == 3 ||
                        orderDetail.orderStatusId == 9 ||
                        orderDetail.orderStatusId == 13
                      "
                    >
                      <template v-slot:button-content>
                        <div class="d-flex">
                          <div class="my-auto">
                            <b-icon icon="printer"></b-icon> พิมพ์เอกสาร
                          </div>
                        </div>
                      </template>
                      <template v-for="print in printSelected">
                        <b-dropdown-item :key="print.id">
                          <div class="d-flex">
                            <div class="my-auto">
                              {{ print.text }}
                            </div>
                          </div>
                        </b-dropdown-item>
                      </template>
                    </b-dropdown>
                  </b-col>
                </b-row>
              </p>
              <p>
                <strong>ช่องทางการจัดส่ง :</strong>ㅤ{{
                  checkTextNull(orderShippingDetail.shippingType)
                }}
              </p>
              <p>
                <strong>Tracking no. :</strong>ㅤ{{
                  checkTextNull(orderShippingDetail.trackingNo)
                }}
              </p>
            </b-container>
          </div>
        </b-col>
      </b-row>
      <OrderDetailPanel
        v-if="dataReady"
        :orderStatus="orderDetail.orderStatusId"
        :orderId="orderDetail.orderId"
        :orderProductDetail="orderProductDetail"
        :orderProductPriceDetail="orderProductPriceDetail"
        :productIdList="productIdList"
        :isOrderMain="isOrderMain"
        :isExchangeable="isExchangeable"
        v-on:returnProduct="returnProduct"
        v-on:handleRoute="handleRoute"
        v-on:handleReload="handleReload"
      />
      <DetailPanel v-if="dataReady" :details="orderStatusLog" />
      <Note
        v-if="dataReady"
        :id="id"
        :note="orderNoteLog"
        v-on:onSubmitNote="getOrderDetails"
      />
      <TaxInvoice
        ref="taxInvoiceModal"
        v-if="dataReady"
        :id="id"
        :shippingAddress="orderAddress"
        :billingAddress="orderTaxAddress"
        :nameTitleOption="nameTitleOption"
      />
      <ModalPaymentDetail
        ref="modalPaymentDetail"
        v-if="dataReady"
        :orderId="id"
        :invoiceNo="orderDetail.invoiceNo || ''"
        :orderTotalAmount="orderProductPriceDetail.totalPrice || 0"
        :isCanEdit="
          orderDetail.orderStatusId == 3 || orderDetail.orderStatusId == 9
        "
        v-on:onRefreshData="hadleModalAlertClose"
      />
      <ModalAlertConfirm
        :msg="titleModal"
        :text="detailModal"
        btnConfirm="ตกลง"
        btnCancel="ยกเลิก"
        ref="isModalAlertConfirm"
        @confirm="acceptAction"
      />
    </div>
  </div>
</template>
<script>
import OrderSimple from "@/assets/mockdata/order/OrderSimple.json";
import OrderDetailPanel from "./components/order-detail/OrderDetailPanal.vue";
// import OrderDetailPanalAddProduct from "./components/order-detail/OrderDetailPanalAddProduct.vue";
import DetailPanel from "./components/detail/DetailPanel.vue";
import Note from "./components/note/Note.vue";
import TaxInvoice from "./components/modal/TaxInvoice.vue";
import ModalPaymentDetail from "./components/modal/ModalPaymentDetail.vue";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import { BIcon } from "bootstrap-vue";
export default {
  name: "OrderDetails",
  components: {
    OrderSimple,
    OrderDetailPanel,
    DetailPanel,
    Note,
    TaxInvoice,
    ModalPaymentDetail,
    ModalAlertConfirm,
    BIcon,
    // OrderDetailPanalAddProduct,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
      dataReady: false,
      modalMessage: "",
      controlTab: isNaN(parseInt(this.$route.query.tab))
        ? 1
        : parseInt(this.$route.query.tab),
      state: {
        isLoading: false,
      },
      orderJson: OrderSimple,
      orderAddress: [],
      orderDetail: [],
      orderNoteLog: [],
      orderProductDetail: [],
      orderProductPriceDetail: {},
      orderShippingDetail: [],
      orderStatusLog: [],
      orderTaxAddress: [],
      nameTitleOption: [],
      printSelected: [
        {
          id: 0,
          text: "พิมพ์ใบปะหน้า",
          value: 1,
        },
        {
          id: 1,
          text: "พิมพ์ใบจัดเตรียมสินค้า",
          value: 2,
        },
      ],
      classEditTaxInvoice: "ml-3 modal-link-active",
      productIdList: [],
      titleModal: "",
      detailModal: "",
      actionType: 0,
      productList: [],
      isOrderMain: false,
      mainOrderId: 0,
      isExchangeable: false,
    };
  },
  created() {
    if (this.$route.name === "รายละเอียดคำสั่งซื้อหลัก")
      this.isOrderMain = true;

    this.getOrderDetails();
    this.getTitleName();
  },
  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    handleRoute() {
      if (this.hasHistory()) this.$router.back();
      else
        this.$router.push({
          path: `/order?brandID=${this.$route.query.brandID}`,
        });
    },
    handleReload() {
      this.getOrderDetails();
    },
    getOrderDetails() {
      let url = `order`;
      if (this.isOrderMain) url = `order/mainOrder`;
      this.dataReady = false;
      this.axios.get(`${this.$baseUrl}/${url}/${this.id}`).then((data) => {
        this.isExchangeable = data.exchangeable || false;
        this.orderDetail = data.orderDetail || null;
        this.orderNoteLog = data.orderNoteLog;
        this.orderProductDetail = data.orderProductDetail;
        this.orderProductPriceDetail = data.orderProductPriceDetail;
        this.orderShippingDetail = data.orderShippingDetail;
        this.orderStatusLog = data.orderStatusLog;
        this.classEditTaxInvoice =
          this.orderDetail.orderStatusId == 2 ||
          this.orderDetail.orderStatusId == 3 ||
          this.orderDetail.orderStatusId == 4
            ? "ml-3 modal-link-active"
            : "ml-3 modal-link-disabled";
        data.orderProductDetail.forEach((e) => {
          this.productIdList.push(e.sku);
        });
        this.mainOrderId = data.mainOrderId || 0;
        if (this.isOrderMain){
          this.getOrderAddress(true);
        }else{
          this.getOrderAddress(false);
        }
      });
    },
    getOrderAddress(isOrderMain) {
      let url = `/transaction/TNL/${this.id}/Address`
      if(isOrderMain) url = `/transaction/main/tnl/${this.id}/Address`
      this.axios
        .get(`${this.$baseUrl}${url}`)
        .then((data) => {
          if (data.result == 1) {
            this.orderAddress = data.detail.shippingAddress;
            this.orderTaxAddress = data.detail.billingAddress;
          }
          this.dataReady = true;
        });
    },
    getTitleName() {
      this.axios.get(`${this.$baseUrl}/filter/NameTitle`).then((data) => {
        if (data.result == 1) {
          this.nameTitleOption = data.detail;
        }
      });
    },
    openPaymentDetail() {
      this.$refs.modalPaymentDetail.show();
    },
    async openTaxInvoice(type) {
      await this.$refs["taxInvoiceModal"].openModal(type);
    },
    checkTextNull(text) {
      return text ? text : "-";
    },
    holdOrder() {
      this.axios
        .put(`${this.$baseUrl}/transaction/HoldOrder`, {
          ListTransactionId: [this.id],
        })
        .then((data) => {
          console.log(`data`, data);
        });
    },
    reRunOrder() {
      this.actionType = 1;
      this.titleModal = "ยืนยันการย้ายไปยังรอยืนยันคำสั่งซื้อ";
      this.detailModal =
        "ต้องการย้ายรายการไปยังรายการรอยืนยันคำสั่งซื้อหรือไม่";
      this.confirmAction();
    },
    reRunOrderConfirm() {
      this.axios
        .put(`${this.$baseUrl}/transaction/RerunOrder`, {
          ListTransactionId: [this.id],
        })
        .then((data) => {
          console.log(`data`, data);
          this.actionType = 0;
          this.titleModal = "";
          this.detailModal = "";
        });
    },
    returnProduct(detail) {
      this.actionType = 2;
      this.productList = detail.data;
      this.titleModal = detail.title;
      this.detailModal = detail.detail;
      this.confirmAction();
    },
    returnProductConfirm() {},
    confirmAction: function () {
      this.$refs.isModalAlertConfirm.show();
    },
    acceptAction() {
      if (this.actionType == 1) {
        this.reRunOrderConfirm();
      } else if (this.actionType == 2) {
        this.returnProductConfirm();
      }
      this.$refs.isModalAlertConfirm.hide();
    },
    hadleModalAlertClose() {
      this.getOrderDetails();
    },
  },
  computed: {
    isDisabled() {
      return this.$route.params.id == 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-gray {
  color: #bcbcbc;
}
.print-selected {
  border-color: #6f67bf;
}
.header-detail {
  .bg-white {
    height: 160px;
  }
}
.modal-link-active {
  color: #b41bb4;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
}
.modal-link-disabled {
  color: #bcbcbc;
  font-size: 14px;
  pointer-events: none;
}
.header-btn {
  font-size: 15px;
  margin-top: 12.5px;
  text-decoration: underline;
}
.seller-image {
  height: 30px;
  width: auto;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
</style>
